import Header from '@/common-utils/components/renders/dataTable/header/Header';
import generateNestedFieldAccessor from './generateNestedFieldAccessor';
import { FILTER_TYPES } from '../components/renders/dataTable/filter/FilterTypes';
import TooltipHelper from '../components/renders/tooltip/TooltipHelper';
import Entity from '../components/renders/entity/Entity';

/**
 * @param root
 * @param root.field
 * @param root.headerPackage
 * @param root.customCellFn
 * @param root.show
 * @param root.isLongText
 * @returns {JSX}
 */
function generateColumnDefByField({ field, headerPackage, customCellFn = undefined, isLongText = false, show = true }) {

    if (!show) {
        return null;
    }

    // Helper
    const getCellValue = (cellule) => {
        return cellule.getValue(
            field.isNested
                ? generateNestedFieldAccessor(field)
                : field.key
        );
    };

    const { query, setQuery, queryStored, storeQuery, setLaunchRefetch, filtersEventName } = headerPackage;
    const cellFn = customCellFn || (({ cell: cellule }) => (
        <>
            {isLongText ?
                <TooltipHelper
                    triggerClass='text-left w-fit max-w-48'
                    trigger={
                        <Entity
                            className='block whitespace-nowrap overflow-hidden text-ellipsis'
                            entity={getCellValue(cellule)}
                        />
                    }
                    content={<Entity entity={getCellValue(cellule)} />}
                />
                : <span>{getCellValue(cellule)}</span>
            }
        </>
    )
    );

    const setFilterInfosByType = () => {
        if (field.filter === FILTER_TYPES.INPUT) {
            return {
                type: FILTER_TYPES.INPUT,
                placeholder: field.placeholder
            };
        }
        if (field.filter === FILTER_TYPES.SELECT) {
            return {
                type: FILTER_TYPES.SELECT,
                values: Object.values(field.enum),
                label: field.entity,
                sortOptions: field.sortOptions ?? false
            };
        }
        if (field.filter === FILTER_TYPES.DATE) {
            return {
                type: FILTER_TYPES.DATE,
                label: field.entity,
                isLocalDateAndTime: field.isLocalDateAndTime
            };
        }
        if (field.filter === FILTER_TYPES.NUMBER) {
            return {
                type: FILTER_TYPES.NUMBER,
                label: field.entity
            };
        }
        if (field.filter === FILTER_TYPES.PLAN) {
            return {
                type: FILTER_TYPES.PLAN,
                label: field.entity
            };
        }
    };

    return {
        header: ({ column }) => (
            <Header
                column={column}
                query={query}
                setQuery={setQuery}
                queryStored={queryStored}
                storeQuery={storeQuery}
                setLaunchRefetch={setLaunchRefetch}
                tooltip={field.tooltip}
                namespace={field.namespace}
                filtersEventName={filtersEventName}
            />
        ),
        accessorKey: field.isNested ? generateNestedFieldAccessor(field) : field.key,
        id: field.isNested ? generateNestedFieldAccessor(field) : field.key,
        enableSorting: field.enableSorting || false,
        sortDescFirst: field.filter === FILTER_TYPES.DATE,
        cell: cellFn,
        entity: field.entity,
        namespace: field.namespace,
        filter: setFilterInfosByType()
    };
}

export default generateColumnDefByField;